import React from 'react';

const TextMarquee = ({ 
  lines = ["it's about time you", "Took", "Up", "Space."],
  speed = 25,
  className = '',
  dark = false
}) => {
  // Create repeated text for seamless scrolling
  const repeatedContent = [...lines, ...lines, ...lines, ...lines];

  return (
    <section 
      className={`py-16 md:py-24 overflow-hidden ${dark ? 'bg-stone-900' : 'bg-vainilla'} ${className}`}
      data-testid="text-marquee"
    >
      <div 
        className="flex whitespace-nowrap"
        style={{
          animation: `scroll-left ${speed}s linear infinite`,
        }}
      >
        {repeatedContent.map((text, index) => (
          <span 
            key={index}
            className={`font-serif text-5xl md:text-7xl lg:text-8xl xl:text-9xl mx-4 md:mx-8 ${
              dark ? 'text-white' : 'text-stone-900'
            } ${index % 2 === 0 ? 'italic font-light' : 'font-bold'}`}
          >
            {text}
          </span>
        ))}
      </div>

      <style jsx="true">{`
        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>
  );
};

export default TextMarquee;
